
import Vue from 'vue'
import {Component, Prop, Watch} from 'vue-property-decorator'
import draggable from 'vuedraggable'
import Multiselect from 'vue-multiselect'
import {namespace} from 'vuex-class'
import {optionsVslim} from '@/config/v-slim-dialog'
import {required} from 'vuelidate/lib/validators'
import {validationMixin} from 'vuelidate'
import {freshdeskEmail, isProduction} from '@/config/service'

const authModule = namespace('auth')
const prospectModule = namespace('prospect')
const mailModule = namespace('mail')
const documentModule = namespace('document')
const propositionModule = namespace('proposition')

@Component({
  components: {
    draggable,
    Multiselect
  },
  mixins: [validationMixin],
  validations: {
    sujetSelected: {
      required
    }
  }
})
export default class ProspectPanel extends Vue {
  @prospectModule.Action('getProspectByIdAction') getProspectById: any
  @mailModule.Action('sendEmailAction') sendEmail: any
  @mailModule.Action('getMailBlocTextsAction') getMailBlocTexts: any
  @mailModule.Action('getMailSujetsAction') getMailSujets: any
  @mailModule.Action('getMailAdresseInternesAction') getMailAdresseInternes: any
  @documentModule.Action('getDocumentsGeneriquesAction') getDocumentsGeneriques: any
  @mailModule.Getter('mailSujetsGetter') mailSujets: any
  @mailModule.Getter('mailBlocTextsGetter') mailBlocs: any
  @mailModule.Getter('mailAdresseInternesGetter') mailAdresseInternes: any
  @authModule.Getter('meGetter') me: any
  @documentModule.Action('getDocumentAction') getDocument: any
  @Prop(Object) proposition!: any
  @Prop(Object) prospect!: any

  sujetSelected = ''
  contentTextArea = ''
  enabled = true
  dragging = false
  list = []
  documentsProspect = []
  documentsProspectOptions = []
  documentsGeneriques = []
  documentsGeneriquesOptions = []
  isLoading = false
  contacts = []
  desti = []
  copie = []
  copieCachee = []
  currentContactEmail = ''

  getEmail(email) {
    this.currentContactEmail = email
  }

  destiCheck() {
    if (this.copie.includes(this.currentContactEmail)) {
      const index = this.copie.indexOf(this.currentContactEmail)
      if (index > -1) {
        this.copie.splice(index, 1)
      }
    }
  }

  copieCheck() {
    if (this.desti.includes(this.currentContactEmail)) {
      const index = this.desti.indexOf(this.currentContactEmail)
      if (index > -1) {
        this.desti.splice(index, 1)
      }
    }
  }

  mounted() {
    this.getMailBlocTexts().then((data) => {
      if (this.proposition) {
        const filterList = data.filter((item) => item.CONTEXTE_PROPOSITION === 1)
        if (filterList.length > 0) {
          const d = []
          filterList.map((item) => {
            d.push({...item, DEFAUT: item.DEFAUT_PROPOSITION})
          })
          this.list = d
        } else {
          this.list = filterList
        }
      } else {
        const filterList = data.filter((item) => item.CONTEXTE_AUTRE === 1)
        if (filterList.length > 0) {
          const d = []
          filterList.map((item) => {
            d.push({...item, DEFAUT: item.DEFAUT_AUTRE})
          })
          this.list = d
        } else {
          this.list = filterList
        }
      }
    })
    this.getMailSujets()
    this.getMailAdresseInternes()
    this.getDocumentsGeneriques().then((data) => {
      this.documentsGeneriquesOptions = data
    })
    // get current document proposition
    const {DOCUMENTS} = this.prospect
    this.documentsProspectOptions = DOCUMENTS
    if (this.proposition) {
      const {ID_DOCUMENT} = this.proposition
      if (ID_DOCUMENT) {
        // find current proposition
        const currentDocumentProposition = DOCUMENTS.find((item) => item.ID === ID_DOCUMENT)
        if (currentDocumentProposition) {
          this.documentsProspect.push(currentDocumentProposition)
        }
      }
    }
  }

  get content() {
    const {CONTACT_PRINCIPAL} = this.prospect
    this.contacts = this.prospect.CONTACTS
    let str: any = ''
    this.list.map((item) => {
      if (item.DEFAUT) {
        const text = item.TEXTE
        const regex = /{NOM}/gi
        if (CONTACT_PRINCIPAL.REF_CIVILITE && CONTACT_PRINCIPAL.NOM) {
          const newText = text.replace(regex, `${CONTACT_PRINCIPAL.REF_CIVILITE.LIBELLE} ${CONTACT_PRINCIPAL.NOM}`)
          str += `${newText}\n\n`
        } else {
          const newText = text.replace(regex, '')
          str += `${newText}\n\n`
        }
      }
    })
    str += `\n${this.me.SIGNATURE_MAIL}`
    return str
  }

  @Watch('content', {deep: false})
  watchContent(val: any) {
    this.contentTextArea = val
  }

  addDocumentProspectHandler() {
    console.log('addDocumentProspectHandler')
  }

  async sendEmailHandler(id: number) {
    this.$v.$touch()
    if (!this.$v.$invalid) {
      if (this.desti.length !== 0) {
        const {ok} = await this.$dialogs.confirm(
          `Confirmez l'envoi de l'email à ${this.desti.join(', ')}` +
            (this.copie.length !== 0 ? ` et en copie à ${this.copie.join(', ')}` : '') +
            ' ?',
          optionsVslim
        )
        if (ok) {
          this.isLoading = true
          const docs = []
          // Documents prospects
          const datasDocumentProspect = await Promise.all(
            this.documentsProspect.map(async (item) => await this.getDocument(item))
          )
          // Documents Generiques
          const datasDocumentGenerique = await Promise.all(
            this.documentsGeneriques.map(async (item) => await this.getDocument(item))
          )
          const data = datasDocumentProspect.concat(datasDocumentGenerique)
          this.sendEmail({
            TO: this.desti,
            CC: this.copie,
            BCC: [...this.copieCachee, freshdeskEmail],
            SUBJECT: this.sujetSelected,
            PLAINTEXT: this.contentTextArea,
            FICHIERS_ATTACHES: data,
            ID_PROPOSITION: this.proposition ? this.proposition.ID : null,
            ID_PROSPECT: this.prospect.ID,
            ID_CONSEILLER: this.me.ID,
            DOCUMENTS_PROSPECT: this.documentsProspect,
            DOCUMENTS_GENERIQUE: this.documentsGeneriques
          }).then(async (data) => {
            await this.getProspectById(this.prospect.ID)
            this.isLoading = false
            this.onCloseHandler()
          })
        }
      } else {
        Vue.notify({
          group: 'user',
          type: 'warn',
          title: 'Attention',
          text: 'Aucun destinataire sélectionné'
        })
      }
    } else {
      // ScrollTop
      const panel: any = document.querySelector('.slideout')
      if (panel) panel.scrollTop = 0
    }
  }

  onCloseHandler() {
    this.$emit('closePanel', {})
  }

  onCopyHandler() {
    Vue.notify({
      group: 'user',
      type: 'success',
      title: 'Confirmation',
      text: "Le contenu de l'email a bien été copié dans le presse papier"
    })
  }

  onCopyErrorHandler() {
    Vue.notify({
      group: 'user',
      type: 'error',
      title: 'Erreur',
      text: "Le contenu de l'email n'a pas pu être copié dans le presse papier, veuillez réessayer"
    })
  }
}
